import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  constructor(
    private translateService: TranslateService,
    private route: ActivatedRoute) {
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translateService.setDefaultLang('de');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translateService.use('de');
  }

  ngOnInit(): void {
    // callback for query parameter
    this.route.queryParams.subscribe(params => {
      if (params.lang) {
        this.translateService.use(params.lang);
      }
    });
  }
}

